import { useApiClient } from "@lib/utils/hooks/useApiClient";
import {
  GeoJsonResponse,
  PathResponse,
  SearchParams,
} from "@repo/shared-types";
import { useState } from "react";

export const useMapSectionCachedPaths = () => {
  const apiClient = useApiClient();
  const [paths, setPaths] = useState<PathResponse[]>([]);
  const [geoJsons, setGeoJsons] = useState<GeoJsonResponse[]>([]);

  const initializeGeoJsons = async () => {
    if (geoJsons.length > 0) {
      return geoJsons;
    }

    const newGeoJsons = await apiClient.getGeoJsonV2();

    setGeoJsons(newGeoJsons);
    return newGeoJsons;
  };

  const searchPaths = async (searchParams: SearchParams) => {
    const geoJsons = await initializeGeoJsons();
    const paths = await apiClient.searchMapPaths({
      ...searchParams,
      pathType: searchParams.pathType || undefined,
    });


    return paths.map(path => ({
      ...path,
      geoJson:
        geoJsons.find(geoJson => geoJson.pathId === path.id)
          ?.geoJson || null,
    }));
  };

  return {
    paths,
    setPaths,
    searchPaths,
  };
};
